export const BAR_MENU = [
    {
        id: "esak-signatures",
        label: "Esak Signatures",
        note: "Bestsellers: Blushing Cherry · Mango Gone Blonde · Ganna On The Rocks",
        items: [
            { name: "Ganna On The Rocks", desc: "Fresh sugarcane juice, elderflower, in-house paan syrup, lime, mint, vodka", price: "499" },
            { name: "Berry Berry Tipsy Tea", desc: "Five spirits, citrus, berry infusion & popping boba, 1000 ml served in a kettle", price: "1399" },
            { name: "Sangria Red", desc: "Red wine steeped with fermented fruits & citrus", price: "799" },
            { name: "Sangria White", desc: "Crisp white wine infused with fermented fruits & citrus", price: "799" },
            { name: "Mango Picante", desc: "Tequila, lime, jalapeño, coriander; a touch of sweet mango heat", price: "649" },
            { name: "Passionfruit Picante", desc: "Tequila, lime, jalapeño, coriander; lifted with bright passionfruit", price: "649" },
            { name: "Rubicon", desc: "Tanqueray, pomegranate, elaichi, finished with honey-rose jelly", price: "649" },
            { name: "Scarlet", desc: "Tempranillo, in-house dehydrated beetroot syrup, fresh orange, silky foam, hibiscus powder", price: "729" },
            { name: "Golden Umami", desc: "Bourbon, chocolate, miso, honey, walnut, yuzu, coconut & jasmine tea", price: "649" },
            { name: "Banoffee", desc: "Camikara, white wine, banana, strawberry & pineapple, a dessert-style cocktail", price: "699" },
            { name: "Blushing Cherry", desc: "Vodka, cherry, litchi, cranberry & fresh lime, soft foam finish", price: "649" },
            { name: "Tiramisu Martini", desc: "Whisky, tiramisu, coffee liqueur & espresso, a smooth dessert cocktail", price: "649" },
            { name: "Masala Beer", desc: "Corona, kala khatta, orange chunks, chaat masala, lemon & black salt", price: "649" },
        ],
    },
    {
        id: "classic-cocktails",
        label: "Classic Cocktails",
        items: [
            { name: "Whiskey Sour", desc: "Bourbon, citrus, egg white", price: "479" },
            { name: "Old Fashioned", desc: "Bourbon, sugar, angostura", price: "479" },
            { name: "Screw Driver", desc: "Vodka, orange juice", price: "479" },
            { name: "Espresso Martini", desc: "Vodka, espresso, coffee liqueur, sugar syrup", price: "479" },
            { name: "Mojito", desc: "White rum, mint, lime, sugar, soda", price: "479" },
            { name: "Daiquiri", desc: "Rum, lime, sugar", price: "479" },
            { name: "Negroni", desc: "Gin, sweet vermouth, campari", price: "479" },
            { name: "French 75", desc: "Gin, lime, sugar, sparkling", price: "479" },
            { name: "Picante", desc: "Tequila, lime, jalapeño, coriander · best with Don Julio Blanco ₹799", price: "499" },
            { name: "Margarita", desc: "Tequila, lime, triple sec, salt rim · best with Patrón Silver ₹599", price: "499" },
            { name: "LIIT", desc: "Tequila, gin, rum, vodka, triple sec, lime, cola", price: "799" },
            { name: "LIIT, Oops, That's Strong", desc: "The classic, supersized, 1000 ml", price: "1399" },
        ],
    },
    {
        id: "jim-beam-cocktails",
        label: "Jim Beam Cocktails",
        items: [
            { name: "Jim Beam Highball", desc: "Crisp, light, refreshing", price: "499" },
            { name: "Jim Beam Orange Tonic", desc: "Bright, citrusy, refreshing", price: "699" },
            { name: "Jim Beam Honey Ginger", desc: "Sweet, spicy, smooth", price: "699" },
            { name: "Jim Beam Black Old Fashioned", desc: "Bold, rich, bittersweet", price: "799" },
        ],
    },
    {
        id: "spritzers",
        label: "Spritzers",
        items: [
            { name: "Bellini", desc: "Peachy, smooth, elegant, a classic Italian sparkler", price: "599" },
            { name: "Mimosa", desc: "Fresh, crisp, bubbly and orange-bright", price: "599" },
            { name: "Limoncello Spritzer", desc: "Bright, zesty, citrus-forward", price: "649" },
            { name: "Aperol Spritzer", desc: "Bittersweet, vibrant, a summer favourite", price: "649" },
        ],
    },
    {
        id: "energy-cocktails",
        label: "Energy Cocktails",
        items: [
            { name: "Red Bull Vodka", desc: "Red Bull energy drink, vodka", price: "599" },
            { name: "Red Bull Tropical Gin", desc: "Red Bull yellow edition, gin", price: "599" },
            { name: "Tequila Melon Bull", desc: "Red Bull red edition, tequila", price: "649" },
        ],
    },
    {
        id: "shots",
        label: "Shots",
        items: [
            { name: "Jägerbomb", desc: "", price: "495" },
            { name: "Kamikaze", desc: "", price: "299" },
            { name: "Poison", desc: "Vodka, strawberry", price: "299" },
            { name: "Painkiller", desc: "Gin, watermelon", price: "299" },
            { name: "Hippie", desc: "Rum, kiwi", price: "299" },
            { name: "Zombie", desc: "Whisky, peach", price: "299" },
            { name: "POV", desc: "Tequila, mango", price: "349" },
        ],
    },
    {
        id: "wines",
        label: "Wines",
        note: "Prices shown as glass / bottle",
        items: [
            { name: "Fishing Cat Pinot Grigio", desc: "White, light, crisp, citrusy", price: "799 / 3699" },
            { name: "Bela Sauvignon Blanc", desc: "White, fresh, aromatic, herbaceous", price: "1199 / 5499" },
            { name: "Fishing Cat Rosato", desc: "Rosé, fruity, floral, refreshing", price: "769 / 3499" },
            { name: "Fishing Cat Merlot", desc: "Red, soft, plummy, smooth", price: "649 / 2899" },
            { name: "Bela Pinot Noir", desc: "Red, elegant, ripe berries, silky", price: "1199 / 5499" },
            { name: "Bela Cabernet Merlot", desc: "Red, bold, dark fruits, structured", price: "1199 / 5499" },
            { name: "Cotton Mouth Chianti", desc: "Red, dry, cherry-led, rustic Italian classic", price: "1299 / 5999" },
            { name: "Fishing Cat Rubicone", desc: "Sparkling, bright, lively, celebratory", price: "929 / 4349" },
            { name: "San Simone Prosecco", desc: "Sparkling, fine bubbles, crisp finish", price: "779 / 3499" },
            { name: "Lambrusco Red Sparkling", desc: "Sparkling, lightly sparkling, fruity, playful finish", price: "1019 / 4789" },
        ],
    },
    {
        id: "beer",
        label: "Beer",
        note: "Bucket offer: order a Heineken or Corona bucket, get 1 pint extra",
        items: [
            { name: "Kingfisher Ultra", desc: "Pint / bucket of 5", price: "389 / 1699" },
            { name: "Erdinger Wheat", desc: "Pint / bucket of 5", price: "499 / 2299" },
            { name: "Heineken", desc: "Pint / bucket of 5", price: "449 / 2049" },
            { name: "Budweiser Premium", desc: "Pint / bucket of 5", price: "389 / 1699" },
            { name: "Corona", desc: "Pint / bucket of 5", price: "499 / 2299" },
            { name: "Hoegaarden", desc: "Pint / bucket of 5", price: "499 / 2299" },
            { name: "Kingfisher Lager (Draught)", desc: "330 ml / 500 ml / 1.5 L / 3 L", price: "409 / 669 / 1699 / 3249" },
            { name: "Budweiser Draught", desc: "330 ml / 500 ml / 1.5 L / 3 L", price: "459 / 709 / 1909 / 3649" },
            { name: "Hoegaarden Draught", desc: "330 ml / 500 ml / 1.5 L / 3 L", price: "509 / 719 / 2219 / 4269" },
        ],
    },
    {
        id: "gin",
        label: "Gin",
        note: "Prices shown as 30 ml / bottle",
        items: [
            { name: "Greater Than", desc: "", price: "369 / 6999" },
            { name: "Bombay Sapphire", desc: "", price: "399 / 7499" },
            { name: "Tanqueray", desc: "", price: "399 / 7499" },
            { name: "Bulldog", desc: "", price: "449 / 8899" },
            { name: "Roku", desc: "", price: "599 / 11499" },
            { name: "Sakura Roku", desc: "", price: "609 / 11699" },
        ],
    },
    {
        id: "vodka",
        label: "Vodka",
        note: "Prices shown as 30 ml / bottle",
        items: [
            { name: "Haku", desc: "", price: "589 / 11099" },
            { name: "Cashmir", desc: "", price: "409 / 7999" },
            { name: "Grey Goose", desc: "", price: "479 / 8999" },
            { name: "Belvedere", desc: "", price: "499 / 9399" },
            { name: "Smoke Lab", desc: "", price: "349 / 6499" },
            { name: "Ketel One", desc: "", price: "409 / 7999" },
            { name: "Smirnoff", desc: "", price: "309 / 5999" },
            { name: "Smirnoff Minty Jamun", desc: "", price: "339 / 6579" },
        ],
    },
    {
        id: "tequila",
        label: "Tequila",
        note: "Prices shown as 30 ml / bottle · Patrón offer: buy 4, get 2 on the house",
        items: [
            { name: "Jose Cuervo Silver", desc: "", price: "429 / 7999" },
            { name: "Patrón Silver", desc: "", price: "679 / 12999" },
            { name: "Patrón Reposado", desc: "", price: "729 / 13599" },
            { name: "Don Julio Blanco", desc: "", price: "729 / 13999" },
            { name: "Don Julio Reposado", desc: "", price: "779 / 14999" },
            { name: "Don 1942", desc: "", price: "1499 / 29999" },
            { name: "El Alto Reposado", desc: "", price: "1799 / 35999" },
            { name: "Creyente Joven Mezcal", desc: "", price: "759 / 11499" },
        ],
    },
    {
        id: "single-malts",
        label: "Single Malts & Irish",
        note: "Prices shown as 30 ml / bottle",
        items: [
            { name: "Indri", desc: "Indian single malt, bold, spice-led", price: "529 / 9999" },
            { name: "Indri Agneya", desc: "Indian single malt, lightly peated, smoky-spice led", price: "559 / 10999" },
            { name: "Godawan No. 2", desc: "Indian craft whisky, rich, spiced", price: "509 / 10599" },
            { name: "Singleton 12", desc: "Soft, mellow, nutty", price: "579 / 11499" },
            { name: "Singleton 15", desc: "Rich, smooth, gently spiced", price: "679 / 12999" },
            { name: "Glenmorangie 12Y", desc: "Smooth, honeyed, floral", price: "549 / 10499" },
            { name: "Glenfiddich 12Y", desc: "Fruity, oak, balanced", price: "579 / 11499" },
            { name: "Glenfiddich 15Y", desc: "Rich, spiced, warm finish", price: "679 / 12999" },
            { name: "Glenfiddich 18Y", desc: "Elegant, deep, refined", price: "899 / 16999" },
            { name: "Aberfeldy", desc: "Rich, spiced, warm finish", price: "529 / 10399" },
            { name: "Teeling Small Batch", desc: "Elegant, deep, refined", price: "629 / 12299" },
            { name: "Laphroaig", desc: "Intense, bold, smoky", price: "519 / 10199" },
            { name: "Bushmills (Irish)", desc: "Light vanilla, toasted grain, smooth Irish finish", price: "449 / 12499" },
        ],
    },
    {
        id: "whisky-bourbon",
        label: "Whisky & Bourbon",
        note: "Prices shown as 30 ml / bottle",
        items: [
            { name: "JW Red Label", desc: "Vibrant, smoky, spicy", price: "379 / 6999" },
            { name: "JW Blonde", desc: "Light, bright, crisp", price: "429 / 8599" },
            { name: "JW Black Label", desc: "Iconic blend, smoky, deep, complex", price: "479 / 9599" },
            { name: "JW Double Black", desc: "Bold, smoky, peaty, intense", price: "629 / 12599" },
            { name: "JW 18", desc: "Rich, smooth vanilla, dark fruit & gentle smoke", price: "959 / 18999" },
            { name: "JW Gold Label", desc: "Smooth, luxurious, honeyed", price: "779 / 21999" },
            { name: "JW Blue Label", desc: "Ultra-premium, rare casks, silky depth", price: "1799 / 35999" },
            { name: "Jim Beam", desc: "Warm vanilla, light spice", price: "399 / 7599" },
            { name: "Jim Beam Black", desc: "Smooth, rich, oaky", price: "479 / 9099" },
            { name: "Jim Beam Orange", desc: "Bright, zesty, citrusy", price: "449 / 8499" },
            { name: "Jim Beam Honey", desc: "Sweet, smooth, mellow", price: "479 / 9099" },
            { name: "Jack Daniel's", desc: "Caramel, oak, signature Tennessee finish", price: "449 / 8999" },
            { name: "Teacher's Highland Cream", desc: "Peaty, smoky, full-bodied", price: "389 / 7249" },
            { name: "Black & White", desc: "Light, clean, approachable", price: "389 / 7299" },
            { name: "Dewar's White Label", desc: "Light honey, soft smoke, easy-drinking", price: "389 / 8299" },
            { name: "Monkey Shoulder", desc: "Vanilla, spice, creamy", price: "529 / 9999" },
            { name: "Dewar's 12Y", desc: "Honeyed sweetness, gentle oak, well-rounded", price: "599 / 11699" },
            { name: "Dewar's 15Y", desc: "Silky honey, dried fruit, refined layered finish", price: "649 / 12699" },
            { name: "Singhasan", desc: "Indian malt whiskey", price: "359 / 5499" },
            { name: "Black Dog Centenary", desc: "Smooth, mellow, easy-going", price: "389 / 7299" },
            { name: "Black Dog Triple Gold Reserve", desc: "Richer blend, layered finish", price: "409 / 7699" },
        ],
    },
    {
        id: "rum-liqueurs",
        label: "Rum, Liqueurs & Cognac",
        note: "Prices shown as 30 ml / bottle",
        items: [
            { name: "Old Monk", desc: "", price: "349 / 6249" },
            { name: "Bacardi White", desc: "", price: "379 / 6789" },
            { name: "Bacardi Mango", desc: "", price: "399 / 6999" },
            { name: "Camikara", desc: "", price: "409 / 7999" },
            { name: "Jägermeister", desc: "", price: "395 / 7499" },
            { name: "Flor de Caña Spresso", desc: "", price: "459 / 8199" },
            { name: "Baileys", desc: "30 ml", price: "409" },
            { name: "Campari", desc: "30 ml", price: "409" },
            { name: "Hennessy VS (Cognac)", desc: "", price: "689 / 20699" },
        ],
    },
];
